import React from "react";
import "./Description.scss";

export default function Description() {
  return (
    <section className="description">
      <div className="description__inner">
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa
          sapiente qui eaque esse nihil illum fugiat in modi, exercitationem cum
          accusantium assumenda laboriosam nisi, quas necessitatibus perferendis
          numquam distinctio recusandae! Lorem ipsum dolor, sit amet consectetur
          adipisicing elit. Consequatur at adipisci pariatur fugit blanditiis
          officia dolor. Ducimus ipsam architecto possimus neque, adipisci dolor
          libero aliquid optio, deleniti ut eos excepturi? Lorem, ipsum dolor
          sit amet consectetur adipisicing elit. Tempora quod laborum dolorum
          perspiciatis aspernatur, nam libero ullam beatae necessitatibus
          maxime. Expedita alias vero rem sequi inventore iste eaque autem
          quasi.
        </p>
      </div>
    </section>
  );
}
